module.exports = __webpack_public_path__ + "img/Group137.a2c22a1b.png";